import type { RotationDegrees } from './index';

/** `rotate(<deg>deg)`, `0deg` when unset. */
export function rotateVar(degrees: RotationDegrees): string {
    return `rotate(${degrees ?? 0}deg)`;
}
